<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 6.3609 6.3609"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-83.124 -128.21)">
      <path
        transform="scale(.26458)"
        d="m317 484.59-2.8281 2.8281 9.1914 9.1934-9.1914 9.1914 2.8281 2.8281 9.1914-9.1914 9.1934 9.1914 2.8281-2.8281-9.1934-9.1914 9.1934-9.1934-2.8281-2.8281-9.1934 9.1934z"
        stop-color="#000000"
        stroke-miterlimit="4.3"
        stroke-width="4.3512"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CloseSvg',
  props: {
    width: {
      type: [Number, String],
      default: '6.3609mm'
    },
    height: {
      type: [Number, String],
      default: '6.3609mm'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>
